export default "__VITE_ASSET__BfOJr7Ki__"